import React from "react";
import Layout from "../../components/Layout";

const AdminProfile = () => {
  return (
    <Layout>
      <h1 className="text-center">This page is under construction.</h1>
    </Layout>
  );
};

export default AdminProfile;
